import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import seoService from '../services/seo'

export const seoGuard = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) => {
  // Set SEO based on route
  switch (to.name) {
    case 'home':
      seoService.setHomeSEO()
      break
    case 'about':
      seoService.setAboutSEO()
      break
    case 'Contact':
      seoService.setContactSEO()
      break
    case 'Properties':
    case 'BuyProperty':
    case 'RentProperty':
    case 'PropertyList': {
      // Get filters from query params or localStorage
      const filters = to.query || {}
      seoService.setPropertiesListSEO(filters)
      break
    }
    case 'PropertyDetails':
      // Property details SEO will be set in the component after data is loaded
      break
    default:
      // Set default SEO
      seoService.setSEO({
        title: 'Estate Rwanda',
        description: 'Find your perfect property in Rwanda with Estate Rwanda. Browse houses, apartments, and commercial properties for sale and rent.',
        type: 'website'
      })
  }

  next()
}
